import { type FormEvent, useState } from 'react';
import { api, json } from '../../api.js';
import styles from './auth.module.css';

export function Gate({ onUnlocked }: { onUnlocked: () => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api('/gate', { method: 'POST', ...json({ password }) });
      onUnlocked();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'That password was not recognized.');
    } finally {
      setBusy(false);
    }
  }

  return <main className={styles.paperView}>
    <section className={styles.invitation} aria-labelledby="gate-title">
      <div className={styles.monogram} aria-hidden="true">C N</div>
      <div className={styles.invitationContent}>
        <p className={styles.eyebrow}>The photographs from</p>
        <h1 id="gate-title">Char <span>and</span> Nick</h1>
        <p className={styles.date}>August 8, 2026 · Chicago</p>
        <form onSubmit={submit} className={styles.passwordForm}>
          <label htmlFor="wedding-password">Enter the album password</label>
          <div className={styles.passwordRow}>
            <input id="wedding-password" autoFocus type="password" autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} required />
            <button className="primary" disabled={!password || busy}>{busy ? 'Checking…' : 'Enter'}</button>
          </div>
          <p className={styles.hint}>Printed on your details card.</p>
          {error ? <p role="alert" className="error">{error}</p> : null}
        </form>
      </div>
    </section>
  </main>;
}
